export default __webpack_public_path__ + "static/media/home-split-portfolio-img-01.66cc01b0.jpg";